import Box from '@/polymorphics/Box';
import Card from '../Card';
import { EntryCardProps } from '../Card/useEntryCard';
import * as styles from './EntryCard.css';

export type ArticleCardProps = EntryCardProps<'article'>;

const ArticleCard = ({ item, ...props }: ArticleCardProps) => {
  const { uri: href, title, pageTitle, summary: description, featuredImage: image } = item;

  return (
    <Card
      {...{
        fullHeight: false,
        props,
      }}
      item={{
        href,
        title: pageTitle ?? title,
        description,
        image,
      }}>
      <Box cx={{ mB: '4' }}>
        <Card.Image ShimProps={{ InnerProps: { className: styles.imageWrap } }} />
      </Box>
      <Card.Body cx={{ mB: '3' }}>
        <Card.Title variant="h3" />
        <Card.Description />
      </Card.Body>
      <Card.Foot>
        <Card.Cta bold iconStroke="currentColor" />
      </Card.Foot>
    </Card>
  );
};

export default ArticleCard;
